import { render, staticRenderFns } from "./EstudiosComponet.vue?vue&type=template&id=265bac56&"
import script from "./EstudiosComponet.vue?vue&type=script&lang=js&"
export * from "./EstudiosComponet.vue?vue&type=script&lang=js&"
import style0 from "./EstudiosComponet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports